export const VIDEO_PUBLISH_DATE_FORMAT = "DD MMM 'YY";

export const PLAYLIST_QUERY_PARAM = 'playlist';
export const PLAYLIST_SLUG_QUERY_PARAM = 'playlistSlug';

export const PLAYLIST_BATCH_SIZE = 12;
export const CAROUSEL_VIDEO_LIMIT = 8;
export const RELATED_VIDEO_LIMIT = 3;
